import { Button, Card, Typography, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import Image from 'next/image'

import { Exchange } from '../../../../../types/exchange'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto 20px auto',

    display: 'flex',
    borderRadius: '2rem',
    flexDirection: 'row',
    position: 'relative',
    overflow: 'visible',
    padding: '30px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    '&.odd': {
      background: 'rgba(0, 0, 0, 0.04)',
    },
  },
  description: {
    marginBottom: '20px',
  },
  imageWrapper: {
    height: '150px',
    width: '100%',
    margin: '.8rem',
    padding: '0 1rem',
    [theme.breakpoints.up('md')]: {
      margin: '0 .4rem',
    },
  },
  imageContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
  },
  button: {},
  title: {},
}))

interface Props {
  exchange: Exchange
  number: number
}

function DexCard({ exchange, number }: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <Card className={`${classes.root} ${number % 2 === 0 ? '' : 'odd'}`} elevation={0}>
      <Grid container>
        <Grid item md={4}>
          <div className={classes.imageWrapper}>
            <div className={classes.imageContainer}>
              <Image objectFit="contain" layout="fill" src={exchange.website_image?.url} />
            </div>
          </div>
        </Grid>
        <Grid item md={8}>
          <div>
            <Typography variant="h5" className={classes.title}>
              {exchange.title}
            </Typography>
            <Typography className={classes.description}>{exchange.short_description}</Typography>
            <Button
              color="primary"
              variant="outlined"
              className={classes.button}
              href={exchange.url}
              target="_blank"
            >
              {`Try ${exchange.title} now!`}
            </Button>
          </div>
        </Grid>
      </Grid>
    </Card>
  )
}

export default DexCard
